import moment from "moment";
import _ from "lodash";
import { DATA_TYPE, SORT_DIRECTION } from "@/constants/common";
import { REPORT_TYPES } from "@/constants/configurableReport";

export const groupByRowOrder = array => {
  const grouped = array.reduce((groups, item) => {
    const rowOrder = item.config.rowOrder;

    if (!groups[rowOrder]) {
      groups[rowOrder] = [];
    }

    groups[rowOrder].push(item);
    return groups;
  }, {});

  // Convert grouped object to the desired array format
  return Object.keys(grouped).map(key => ({
    rowOrder: parseInt(key, 10), // Convert key to number
    value: grouped[key]
  }));
};

export const getCellValue = (columnConfig, rowValue) => {
  let cellValue = _.cloneDeep(rowValue[columnConfig.dataKey]);
  if (cellValue == null) {
    return columnConfig.defaultValue != null ? columnConfig.defaultValue : "";
  }
  if (columnConfig.dateTimeFormat) {
    cellValue = moment(cellValue).format(columnConfig.dateTimeFormat);
  }
  if (columnConfig.toUpperCase) {
    cellValue = cellValue.toUpperCase();
  }
  if (columnConfig.unit) {
    let unit = _.cloneDeep(columnConfig.unit);
    if (columnConfig.pluralUnit && Number(cellValue) != 1) {
      unit += "s";
    }
    if (columnConfig.spaceBetweenUnit !== false) {
      cellValue = `${cellValue} ${unit}`;
    } else {
      cellValue = `${cellValue}${unit}`;
    }
  }
  return cellValue;
};

export const getCsvCellValue = (columnConfig, rowValue) => {
  return `="${getCellValue(columnConfig, rowValue)}"`;
};

export const objectToStyleString = styleObject => {
  return Object.entries(styleObject)
    .map(([key, value]) => `${key.replace(/([A-Z])/g, "-$1").toLowerCase()}: ${value};`)
    .join(" ");
};

const getValue = (item, key) => (item && item[key] !== undefined ? item[key] : null);

const compareValues = (valA, valB, isAsc, fieldType) => {
  if (valA == null && valB == null) {
    return 0;
  }
  if (valA == null) {
    return isAsc ? -1 : 1;
  }
  if (valB == null) {
    return isAsc ? 1 : -1;
  }

  if (fieldType === DATA_TYPE.NUMBER) {
    return isAsc ? valA - valB : valB - valA;
  }

  const aStr = String(valA);
  const bStr = String(valB);
  return isAsc ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr);
};

export const handleSortingData = (calculatedStatisticData, orderBy, sortDirection, fieldType) => {
  if (![SORT_DIRECTION.ASC, SORT_DIRECTION.DESC].includes(sortDirection)) {
    return calculatedStatisticData;
  }

  const isAsc = sortDirection === SORT_DIRECTION.ASC;

  return [...calculatedStatisticData].sort((a, b) => compareValues(getValue(a, orderBy), getValue(b, orderBy), isAsc, fieldType));
};

// SUPERSET is a rendering hint, not a list section: these reports appear
// under the existing Custom reports heading.
export const getReportSectionType = report => (report.type === REPORT_TYPES.SUPERSET ? REPORT_TYPES.CUSTOM : report.type);
